import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

type APIPayload = {
    id: string;
    store_id: string;
    email: string;
    name: string;
    is_active: boolean;

};

export const editMember = async (payload: APIPayload) => {
    const { id, ...rest } = payload;
    try {
        const response = await Axios.put(`/users/member/${id}`, rest);
        return response.data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useEditMember = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload: APIPayload) => editMember(payload),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ["get-all-members"] });
            console.log({ data });
        },
        onError: (error) => {
            toast.error("Unable to edit user.", { description: error.message });
            console.log({ error });
        },
    });
};
